import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  standalone: true
})
export class TermsOfUseComponent {
  public dialogRef = inject<MatDialogRef<TermsOfUseComponent>>(MatDialogRef);

  close() {
    this.dialogRef.close();
  }
}
